var exports = {
  "k": "x936d19a0--23cbe4--container",
  "L": "x936d19a0--23cbe4--input-container",
};

module.exports = exports;
